import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useSnackbar } from '@lyearn/ui';
import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { ArticleContentType, UpdateArticleInput } from '@/types/schema';

import { useUpdateArticleMutation } from '../graphql/mutation/generated/UpdateArticle';

const useSharedArticleUpdate = (content: ArticleContentType) => {
  const { t } = useTranslation();
  const { showSnackbar } = useSnackbar();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();
  const [, updateArticle] = useUpdateArticleMutation();

  const onUpdateContent = useCallback(
    async (contentData?: UpdateArticleInput) => {
      const updateContent = await updateArticle({
        article: {
          articleId: content.id,
          ...contentData,
        },
      });
      if (!updateContent.data?.updateArticle.success) {
        showDefaultErrorSnackbar();
      } else {
        showSnackbar({ message: t('Common:UpdateContentSuccess') });
      }
      return true;
    },
    [content?.id, showDefaultErrorSnackbar, showSnackbar, t, updateArticle],
  );

  return { onUpdateContent };
};

export default useSharedArticleUpdate;
